import React from 'react';
import GroupToken from './GroupToken';

export default function And(props) {
	return <GroupToken operator="or" label="&or;" border="primary" {...props} />;
}
